import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getSingleTemplateDetail, updateTemplate } from "../../../../utils/instagramFeedApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplateWidget from "../../../../components/Apps/InstagramFeed/Template/CommonTemplateWidget";

//Import Tabs
import SourcesTab from "../../../../components/Apps/InstagramFeed/SourcesTab";
import LayoutTab from "../../../../components/Apps/InstagramFeed/LayoutTab";
import PostTab from "../../../../components/Apps/InstagramFeed/PostTab";
import StyleTab from "../../../../components/Apps/InstagramFeed/StyleTab";
import SettingsTab from "../../../../components/Apps/InstagramFeed/SettingsTab";

export default function EditInstagramFeed() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Sources");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Instagram Feed");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [instagramFeedTabData, setInstagramFeedTabData] = useState({
        is_website_frontend: "", 
        source_type: "account",  
        source_search_name: "",
        columns_mode_type: "auto",  
        layout_columns: 4,  
        layout_rows: 2,  
        layout_item_spacing: 5, 
        layout_is_full_width: 0,     
        layout_custom_width: "1280",    
        header_is_show_header: 1, 
        header_profile_picture: 1, 
        header_full_name: 1, 
        header_username: 1, 
        header_verified_badge: 1, 
        header_posts_count: 1, 
        header_followers_count: 1, 
        header_following_count: 1, 
        header_follow_button: 1, 
        feed_title: "", 
        language_type: "English", 
        post_likes_count: 1,
        post_comments_count: 1,
        post_text: 1,
        popup_user: 1,
        popup_instagram_link: 1,
        popup_likes_count: 1,
        popup_share: 1,
        popup_text: 1,
        popup_comments: 1,
        popup_date: 1,
        post_click_action: "None",
        header_background_color: "",
        header_text_color: "",
        header_follow_button_color: "",
        header_follow_button_text_color: "",
        header_post_overlay_background: "",
        header_post_overlay_text: "",
        load_more_button: "",
        popup_color_overlay: "",
        popup_background_color: "",
        popup_text_color: "",
        popup_links_color: "",
        popup_follow_button_color: "",
        popup_action_button_color: "",
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateInstagramFeedTabData = (key, value) => {
        setInstagramFeedTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
      { key: "Sources", icon: "sources.png", label: "Sources" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Post", icon: "post.png", label: "Post" },
      { key: "Style", icon: "style.png", label: "Style" },
      { key: "Settings", icon: "settings.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getSingleTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.temp_detail.uuid);
                    setWidgetName(templateResult.data.temp_detail.name);
                    setActiveTemplateSection(templateResult.data.temp_detail.template_name);
                    setSelectedLayout(templateResult.data.temp_detail.layout_type);
                    setSelectedTemplateImage(templateResult.data.temp_detail.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setInstagramFeedTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setInstagramFeedTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(instagramFeedTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                source_type: instagramFeedTabData.source_type,
                username_or_url: instagramFeedTabData.source_search_name,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplate(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/instagram-feed');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handle Layout Change
    const handleLayoutChange = (e) => {
        setSelectedLayout(e.target.value);
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/instagram-feed/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Sources" && (
                        <SourcesTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                    )}
                    {activeSection === "Post" && (
                        <PostTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                    )}
                    {activeSection === "Settings" && (
                        <SettingsTab updateInstagramFeedTabData={updateInstagramFeedTabData} instagramFeedTabData={instagramFeedTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/instagram-feed"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/instagram-feed/instagram-feed.svg`} alt="instagram-feed"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/instagram-feed/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/instagram-feed" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Instagram Feed <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common Template Widgets*/}
                    <CommonTemplateWidget selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} instagramFeedTabData={instagramFeedTabData} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 